import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { doc, getDoc } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase/config';

// Native only: a backgrounded app can sit for hours or days before the user
// returns to it. On resume, force a fresh ID token — role/claims can change
// server-side while the app was asleep — and re-run the same salesTeam
// active check Login.js's routeAfterAuth runs at sign-in, so a deactivated
// rep is kicked out on resume instead of only at their next explicit login.
// No-op on web: browser tabs don't get a Capacitor 'resume' event, and the
// existing sign-in-time check already covers that platform.
export default function useAppResumeAuthCheck() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return undefined;

    async function checkOnResume() {
      const user = auth.currentUser;
      if (!user) return;
      try {
        const result = await user.getIdTokenResult(true);
        const role = result.claims.role || null;
        if (role !== 'sales_rep' && role !== 'sales_manager') return;
        const snap = await getDoc(doc(db, 'salesTeam', user.uid));
        if (snap.exists() && snap.data().active === false) {
          await signOut(auth);
        }
      } catch {
        // Transient connectivity failure on resume — don't sign out for
        // that; PrivateRoute/AgreementGate still gate the next navigation.
      }
    }

    const listenerHandle = CapacitorApp.addListener('resume', checkOnResume);
    return () => { listenerHandle.then(h => h.remove()); };
  }, []);
}
